export const MenuIcon = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0.5C0 0.223858 0.223858 0 0.5 0H11.5C11.7761 0 12 0.223858 12 0.5C12 0.776142 11.7761 1 11.5 1H0.5C0.223858 1 0 0.776142 0 0.5ZM0.646447 2.64645C0.841709 2.45118 1.15829 2.45118 1.35355 2.64645L3.35355 4.64645C3.54882 4.84171 3.54882 5.15829 3.35355 5.35355L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645L2.29289 5L0.646447 3.35355C0.451184 3.15829 0.451184 2.84171 0.646447 2.64645ZM5 3.5C5 3.22386 5.22386 3 5.5 3H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H5.5C5.22386 4 5 3.77614 5 3.5ZM5 6.5C5 6.22386 5.22386 6 5.5 6H11.5C11.7761 6 12 6.22386 12 6.5C12 6.77614 11.7761 7 11.5 7H5.5C5.22386 7 5 6.77614 5 6.5ZM0 9.5C0 9.22386 0.223858 9 0.5 9H11.5C11.7761 9 12 9.22386 12 9.5C12 9.77614 11.7761 10 11.5 10H0.5C0.223858 10 0 9.77614 0 9.5Z"
      fill="#6d8afa"
    />
  </svg>
);
export const CoinIcon = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.1298 14.2425C35.089 13.2971 34.164 12.5421 32.3752 11.998C30.9877 11.5831 29.2261 11.3314 27.3217 11.2906V4.03346C27.3149 3.91103 27.2809 3.79541 27.2197 3.69339C27.0293 2.87041 26.1111 2.20386 24.4855 1.71416C22.9552 1.25165 20.9555 1 18.8539 1C16.759 1 14.7798 1.25165 13.2767 1.71416C12.0456 2.09504 10.5697 2.80239 10.5697 4.01986C10.5697 4.09467 10.5765 4.16949 10.5901 4.24431L10.6649 7.34578C6.24394 6.5024 1.97941 9.40663 1.14283 13.8208C1.04761 14.3241 1 14.8274 1 15.3375C1 19.8265 4.6524 23.4789 9.14137 23.4789C11.0118 23.4789 12.821 22.8396 14.2697 21.6561C15.5416 21.9554 17.0379 22.1186 18.6226 22.1322C18.9695 24.0162 23.0504 24.88 26.8524 24.88C28.9473 24.88 30.9265 24.6215 32.4296 24.1522C33.6607 23.7714 35.1366 23.0572 35.1366 21.8397V14.3717C35.1366 14.3309 35.1366 14.2833 35.1298 14.2425ZM25.9002 7.79468C25.9002 7.8831 25.5738 8.3524 24.0978 8.8013C22.7171 9.21619 20.8059 9.46104 18.8607 9.46104C17.1807 9.46104 15.5348 9.2842 14.2289 8.95093C14.2085 8.94413 14.1949 8.94413 14.1745 8.93733C13.5283 8.42722 12.8142 8.01913 12.0456 7.73347L11.998 5.81545C12.4673 6.0535 12.957 6.24394 13.4671 6.37997C14.943 6.80846 16.8543 7.03971 18.8607 7.03971C20.9555 7.03971 22.962 6.78806 24.4923 6.32556C25.0024 6.17593 25.4989 5.97868 25.9682 5.73383V7.51582C25.8934 7.61104 25.9002 7.69946 25.9002 7.79468ZM13.6848 3.02684C15.0587 2.60515 16.8951 2.3671 18.8539 2.3671C20.7991 2.3671 22.7103 2.60515 24.091 3.02684C25.567 3.47574 25.8934 3.93824 25.8934 4.02666C25.8934 4.12188 25.5602 4.59118 24.0842 5.03328C22.7035 5.44817 20.7991 5.68622 18.8539 5.68622C16.9767 5.68622 15.1947 5.46857 13.8412 5.07409C12.3789 4.6524 11.9708 4.18989 11.9368 4.04026C11.9368 4.02666 11.93 4.02666 11.93 4.02666C11.9368 3.89743 12.2497 3.46214 13.6848 3.02684ZM13.7052 20.357C10.937 22.8736 6.64523 22.6763 4.12868 19.9081C1.61213 17.1399 1.80938 12.8482 4.57758 10.3316C5.82225 9.19579 7.45461 8.57005 9.14137 8.57005C9.82152 8.57005 10.4949 8.67207 11.1478 8.86931C13.5079 9.60387 15.2831 11.5627 15.7864 13.9772C15.8748 14.4261 15.9225 14.8886 15.9225 15.3443C15.9293 17.2555 15.1199 19.0715 13.7052 20.357ZM15.4327 20.5066C15.9837 19.8333 16.4258 19.0783 16.7386 18.269C17.3168 18.3166 17.9153 18.3506 18.541 18.3574V18.4798L18.5818 20.7855C17.5276 20.7719 16.4734 20.6767 15.4327 20.5066ZM17.2487 14.5349C17.6432 14.5622 18.0581 14.5758 18.4798 14.5826L18.5206 16.9903C18.0445 16.9835 17.5752 16.9631 17.1263 16.9291C17.2283 16.4054 17.2827 15.868 17.2827 15.3375C17.2827 15.0723 17.2691 14.807 17.2487 14.5349ZM18.9219 13.2291H18.8539C18.2009 13.2291 17.5684 13.2019 16.9835 13.161C16.725 12.2496 16.3169 11.3927 15.766 10.6309C16.7862 10.7601 17.8133 10.8281 18.8471 10.8281C20.9487 10.8281 22.9552 10.5765 24.4855 10.114C24.9956 9.96435 25.4853 9.76711 25.9546 9.52906V11.311C23.0368 11.3927 20.0373 12.0048 18.9219 13.2291ZM19.8197 14.3105C19.8197 14.3037 19.8197 14.2969 19.8265 14.2833C19.8877 14.0997 20.3706 13.6508 21.7785 13.2563C23.098 12.8822 24.8188 12.6781 26.628 12.6781H26.7436C28.6888 12.6781 30.5932 12.9026 31.9807 13.3243C33.4295 13.7596 33.7695 14.2085 33.7763 14.3105V14.3173C33.7695 14.4193 33.4295 14.8886 31.9195 15.3375C30.5252 15.7524 28.6888 15.9769 26.7504 15.9769C24.8732 15.9769 23.0912 15.7592 21.7377 15.3715C20.2754 14.9498 19.8741 14.4805 19.8333 14.3377L19.8197 14.3105ZM32.0352 22.86C30.6613 23.2885 28.8181 23.5265 26.8592 23.5265C24.8936 23.5265 23.0572 23.2953 21.6969 22.8804C20.2618 22.4383 19.9625 21.9826 19.9625 21.8805V21.8669L19.9285 19.8945C20.4726 20.1598 21.0372 20.3638 21.6221 20.5134C23.0504 20.8875 24.8664 21.0984 26.73 21.0984C28.8317 21.0984 30.8245 20.8467 32.348 20.3842C32.8445 20.2346 33.3206 20.0373 33.7763 19.8061V21.8465H33.7831C33.7831 21.9418 33.4703 22.4111 32.0352 22.86ZM33.7899 17.8541H33.7831C33.7831 17.9221 33.7423 18.0037 33.7423 18.0785C33.7423 18.1737 33.4227 18.6362 31.9535 19.0851C30.5592 19.5068 28.7024 19.7381 26.7368 19.7381C22.9688 19.7381 20.4318 18.8879 19.9013 18.2282L19.8945 17.6568L19.8673 16.0925C20.3434 16.3305 20.8399 16.521 21.35 16.6638C22.826 17.0923 24.7372 17.3236 26.7436 17.3236C28.8113 17.3236 30.7837 17.0787 32.3004 16.6298C32.8173 16.487 33.3138 16.2897 33.7899 16.0449V17.8541Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M11.618 16.3018C11.3052 15.1932 10.2917 14.4314 9.14228 14.4314C8.47574 14.4314 7.93162 13.8941 7.93162 13.2276C7.93842 12.5542 8.47574 12.0169 9.14228 12.0169C9.80883 12.0169 10.3529 12.561 10.3529 13.2276C10.3529 13.6017 10.659 13.9077 11.0331 13.9077C11.4072 13.9077 11.7132 13.6017 11.7132 13.2276C11.7132 12.0781 10.9515 11.0647 9.84284 10.7518V10.4458C9.84284 10.0717 9.53677 9.76562 9.16269 9.76562C8.78861 9.76562 8.48254 10.0717 8.48254 10.4458V10.7382C7.11544 11.1055 6.29926 12.5134 6.66654 13.8805C6.96581 15.0028 7.97923 15.7849 9.14228 15.7849C9.80883 15.7849 10.3529 16.3223 10.3529 16.9888C10.3529 17.6553 9.81563 18.1995 9.14909 18.1995C8.48254 18.1995 7.93842 17.6621 7.93842 16.9956C7.93842 16.6215 7.63235 16.3155 7.25827 16.3155C6.88419 16.3155 6.57812 16.6215 6.57812 16.9956C6.58493 18.1587 7.3603 19.1721 8.48254 19.4781V20.0699C8.48254 20.4439 8.78861 20.75 9.16269 20.75C9.53677 20.75 9.84284 20.4439 9.84284 20.0699V19.4713C11.2099 19.0837 12.0057 17.6689 11.618 16.3018Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);
export const MoneyIcon = () => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_389_4867)">
      <mask
        id="mask0_389_4867"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="37"
        height="37"
      >
        <path
          d="M35.9999 36V1.00011H1V36H35.9999Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
        />
      </mask>
      <g mask="url(#mask0_389_4867)">
        <path
          d="M16.2578 22.9082C16.2578 21.7109 15.2871 20.7403 14.0898 20.7403C12.8925 20.7403 11.9219 21.7109 11.9219 22.9082C11.9219 24.1055 12.8925 25.0762 14.0898 25.0762C15.2871 25.0762 16.2578 26.0469 16.2578 27.2441C16.2578 28.4414 15.2871 29.4121 14.0898 29.4121C12.8925 29.4121 11.9219 28.4414 11.9219 27.2441"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0898 18.5723V20.7402"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0898 29.4121V31.5801"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9218 9.75593C11.9218 18.4278 1.08203 18.5723 1.08203 31.5801C1.08203 31.6457 1.08254 31.7113 1.08355 31.7767C1.11983 34.0954 3.10337 35.916 5.42236 35.916H22.7572"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58594 1.08401C7.58594 1.08401 11.9219 5.41993 11.9219 9.75586"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2578 9.75591C16.2578 17.3365 24.5411 18.435 26.6259 27.2441"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5937 1.08401C20.5937 1.08401 16.2578 5.41993 16.2578 9.75586"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58594 1.08399C10.8379 1.08399 10.8379 3.25195 14.0898 3.25195C17.3418 3.25195 17.3418 1.08399 20.5937 1.08399"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75391 9.75586H18.4258"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.7617 31.5801H35.914M22.7617 31.5801V35.916H35.914V31.5801M22.7617 31.5801V27.2442H35.914V31.5801"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_389_4867">
        <rect width="37" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TrendingIcon = () => (
  <svg
    width="32"
    height="36"
    viewBox="0 0 32 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 34.332H31"
      stroke="#6D8AFA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 25.9993C1 27.5707 1 28.3564 1.48816 28.8445C1.97631 29.3327 2.76198 29.3327 4.33333 29.3327C5.90468 29.3327 6.69036 29.3327 7.17851 28.8445C7.66667 28.3564 7.66667 27.5707 7.66667 25.9993V15.9993C7.66667 14.428 7.66667 13.6423 7.17851 13.1542C6.69036 12.666 5.90468 12.666 4.33333 12.666C2.76198 12.666 1.97631 12.666 1.48816 13.1542C1 13.6423 1 14.428 1 15.9993V19.3327"
      stroke="#6D8AFA"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12.668 9.33333C12.668 7.76198 12.668 6.97631 13.1561 6.48816C13.6443 6 14.43 6 16.0013 6C17.5727 6 18.3583 6 18.8465 6.48816C19.3346 6.97631 19.3346 7.76198 19.3346 9.33333V26C19.3346 27.5713 19.3346 28.357 18.8465 28.8452C18.3583 29.3333 17.5727 29.3333 16.0013 29.3333C14.43 29.3333 13.6443 29.3333 13.1561 28.8452C12.668 28.357 12.668 27.5713 12.668 26V9.33333Z"
      stroke="#6D8AFA"
      strokeWidth="2"
    />
    <path
      d="M30.9987 16V26C30.9987 27.5713 30.9987 28.357 30.5105 28.8452C30.0224 29.3333 29.2367 29.3333 27.6654 29.3333C26.094 29.3333 25.3083 29.3333 24.8202 28.8452C24.332 28.357 24.332 27.5713 24.332 26V4.33333C24.332 2.76198 24.332 1.97631 24.8202 1.48816C25.3083 1 26.094 1 27.6654 1C29.2367 1 30.0224 1 30.5105 1.48816C30.9987 1.97631 30.9987 2.76199 30.9987 4.33333V9.33333"
      stroke="#6D8AFA"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const TrendIcon = () => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0152 29.6278C13.9976 29.575 14.9761 29.4644 15.9455 29.2967V38.4584H13.0152L13.0152 29.6278ZM1 38.4583H3.93062V29.6667H1V38.4583ZM7.00767 29.6667V38.4583H9.93806V29.6667H7.00767ZM30.9643 38.4583H33.8949V16.1827C33.0767 17.7489 32.0943 19.2236 30.9643 20.582V38.4583ZM24.957 38.4583H27.8872V23.6932C26.9638 24.4793 25.9845 25.1972 24.957 25.8413V38.4583ZM18.9494 28.5807V38.4583H21.88V27.4828C21.7227 27.5536 21.5646 27.6226 21.4057 27.6899C20.6029 28.0292 19.783 28.3266 18.9494 28.5807ZM32.3353 1L26.1186 7.21644L28.1909 9.28873L30.7679 6.71178C29.6839 16.3163 21.5124 23.8056 11.6229 23.8056H1V26.7361H11.6229C17.5525 26.7361 23.1272 24.4269 27.32 20.2341C31.0366 16.5175 33.2718 11.714 33.7314 6.54074L36.4277 9.23699L38.5 7.1647L32.3353 1Z"
      fill="white"
      stroke="#5C75D8"
      strokeWidth="0.5"
    />
  </svg>
);
export const CloseIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L4 3.29289L6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447C7.54882 0.841709 7.54882 1.15829 7.35355 1.35355L4.70711 4L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355C7.15829 7.54882 6.84171 7.54882 6.64645 7.35355L4 4.70711L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645L3.29289 4L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z"
      fill="#6d8afa"
    />
  </svg>
);

export const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g clipPath="url(#clip0_980_998)">
      <path
        d="M20.5 0C9.17855 0 0 9.17855 0 20.5C0 31.8214 9.17855 41 20.5 41C31.8214 41 41 31.8214 41 20.5C41 9.17855 31.8214 0 20.5 0Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M22.7427 18.645L31.5185 8.44385H29.4389L21.8189 17.3014L15.7328 8.44385H8.7132L17.9165 21.838L8.7132 32.5355H10.7929L18.8399 23.1816L25.2672 32.5355H32.2868L22.7421 18.645H22.7427ZM11.5422 10.0094H14.7365L29.4398 31.0411H26.2456L11.5422 10.0094Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_980_998">
        <rect width="41" height="41" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g clipPath="url(#clip0_303_516)">
      <circle cx="20.5" cy="20.5" r="20.5" fill="#242424" className="icon-bg" />
      <path
        d="M25.2872 21.7222L25.8592 17.9486H22.2864V15.5042C22.2864 14.4694 22.788 13.4703 24.3808 13.4703H26V10.2587C26 10.2587 24.5304 10 23.1224 10C20.1832 10 18.2648 11.802 18.2648 15.076V17.9486H15V21.7222H18.2648V30.8394C18.916 30.9465 19.5936 31 20.2712 31C20.9488 31 21.6264 30.9465 22.2776 30.8394V21.7222H25.2784H25.2872Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_303_516">
        <rect width="41" height="41" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkdinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g clipPath="url(#clip0_303_527)">
      <path
        d="M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M11.9046 16.686H15.8728V29.446H11.9046V16.686ZM13.8957 10.3481C15.1717 10.3481 16.1953 11.3717 16.1953 12.6477C16.1953 13.9237 15.1717 14.9473 13.8957 14.9473C12.6197 14.9473 11.5961 13.9097 11.5961 12.6477C11.5961 11.3858 12.6197 10.3481 13.8957 10.3481Z"
        fill="white"
      />
      <path
        d="M18.3687 16.6863H22.1686V18.425H22.2247C22.7575 17.4154 24.0475 16.3638 25.9826 16.3638C29.9928 16.3638 30.736 18.9999 30.736 22.4352V29.4322H26.7678V23.2345C26.7678 21.7482 26.7397 19.8552 24.7066 19.8552C22.6734 19.8552 22.3228 21.4677 22.3228 23.1363V29.4462H18.3546V16.6863H18.3687Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_303_527">
        <rect width="41" height="41" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
  >
    <g clipPath="url(#clip0_303_531)">
      <path
        d="M21.5 43C33.3741 43 43 33.3741 43 21.5C43 9.62588 33.3741 0 21.5 0C9.62588 0 0 9.62588 0 21.5C0 33.3741 9.62588 43 21.5 43Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M33.0147 18.3825C33.0147 15.5295 30.7059 13.2207 27.8529 13.2207H14.6471C11.7941 13.2207 9.48529 15.5295 9.48529 18.3825V24.5295C9.48529 27.3825 11.7941 29.6913 14.6471 29.6913H27.8529C30.7059 29.6913 33.0147 27.3825 33.0147 24.5295V18.3825ZM25.25 21.9119L19.3235 24.8383C19.0882 24.9707 18.3088 24.7942 18.3088 24.5295V18.5148C18.3088 18.2501 19.1029 18.0736 19.3382 18.206L25 21.2942C25.2353 21.4266 25.4853 21.7795 25.25 21.8972V21.9119Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_303_531">
        <rect width="43" height="43" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g clipPath="url(#clip0_303_519)">
      <path
        d="M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M26.8659 12.7461C26.0947 12.7461 25.4637 13.3771 25.4637 14.1483C25.4637 14.9195 26.0947 15.5645 26.8659 15.5645C27.6371 15.5645 28.2821 14.9335 28.2821 14.1483C28.2821 13.3631 27.6512 12.7461 26.8659 12.7461Z"
        fill="white"
      />
      <path
        d="M20.5981 14.5547C17.331 14.5547 14.6809 17.2048 14.6809 20.4719C14.6809 23.739 17.331 26.3892 20.5981 26.3892C23.8652 26.3892 26.5154 23.739 26.5154 20.4719C26.5154 17.2048 23.8652 14.5547 20.5981 14.5547ZM20.5981 24.2719C18.5089 24.2719 16.8122 22.5752 16.8122 20.4859C16.8122 18.3967 18.5089 16.7 20.5981 16.7C22.6874 16.7 24.3841 18.3967 24.3841 20.4859C24.3841 22.5752 22.6874 24.2719 20.5981 24.2719Z"
        fill="white"
      />
      <path
        d="M25.2955 32.4886H15.7045C11.7223 32.4886 8.48322 29.2495 8.48322 25.2673V15.6764C8.48322 11.6941 11.7223 8.45508 15.7045 8.45508H25.2955C29.2777 8.45508 32.5167 11.6941 32.5167 15.6764V25.2673C32.5167 29.2495 29.2777 32.4886 25.2955 32.4886ZM15.7045 10.7126C12.9702 10.7126 10.7407 12.9421 10.7407 15.6764V25.2673C10.7407 28.0016 12.9702 30.2311 15.7045 30.2311H25.2955C28.0297 30.2311 30.2592 28.0016 30.2592 25.2673V15.6764C30.2592 12.9421 28.0297 10.7126 25.2955 10.7126H15.7045Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_303_519">
        <rect width="41" height="41" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DiscordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
  >
    <g clipPath="url(#clip0_1283_689)">
      <path
        d="M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M12.0183 23.8228C17.1628 25.8304 21.5408 26.2215 26.5019 23.0965C26.4656 23.151 25.4842 24.6049 22.9035 25.35C23.4487 26.0952 24.1938 26.9493 24.1938 26.9493C25.8477 26.9493 27.4652 26.4768 28.8645 25.5681C29.955 24.8411 30.5728 23.5872 30.4456 22.2787C30.2275 20.0433 29.7005 17.8624 28.8827 15.7724C27.8468 13.0464 25.357 11.1563 22.4673 10.8836C22.2129 10.8655 22.0312 10.8655 21.9221 10.8655L21.6314 11.1562C24.9572 12.1013 26.611 13.5733 26.6473 13.6279C21.5405 11.0472 15.5068 11.0109 10.3635 13.5189C10.3635 13.5189 11.9992 11.9014 15.6157 11.0472L15.3977 10.8291C15.016 10.8291 14.6525 10.8655 14.2709 10.92C11.5993 11.3743 9.36397 13.2099 8.40073 15.736C7.56472 17.9169 7.01952 20.2068 6.81962 22.5331C6.71058 23.7689 7.29215 24.9866 8.30988 25.6953C9.65473 26.5858 11.254 27.0584 12.8715 27.0584C12.8715 27.0584 13.5257 26.2042 14.18 25.4409C11.7265 24.7139 10.727 23.26 10.7088 23.2055L11.1706 23.4413C11.4466 23.5825 11.7295 23.7098 12.0183 23.8228ZM14.8706 22.2423C13.6893 22.2059 12.7625 21.2064 12.7988 20.0069C12.8352 18.8801 13.7439 17.9714 14.8706 17.9351C16.052 17.9714 16.9788 18.971 16.9425 20.1705C16.8879 21.2973 15.9974 22.206 14.8706 22.2423ZM22.2856 22.2423C21.1042 22.2059 20.1774 21.2064 20.2137 20.0069C20.2501 18.8801 21.1588 17.9714 22.2856 17.9351C23.4669 17.9714 24.3937 18.971 24.3574 20.1705C24.3211 21.2973 23.4123 22.206 22.2856 22.2423Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1283_689">
        <rect width="37" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TelegramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
  >
    <g clipPath="url(#clip0_1283_681)">
      <path
        d="M18.5 0C8.28308 0 0 8.28308 0 18.5C0 28.7169 8.28308 37 18.5 37C28.7169 37 37 28.7169 37 18.5C37 8.28308 28.7169 0 18.5 0Z"
        fill="#242424"
        className="icon-bg"
      />
      <path
        d="M15.4685 21.8535L15.1115 26.875C15.6223 26.875 15.8435 26.6556 16.1088 26.3921L18.5035 24.1035L23.4656 27.7374C24.3757 28.2446 25.0168 27.9775 25.2623 26.9002L28.5194 11.6379L28.5203 11.637C28.809 10.2917 28.0338 9.76566 27.1472 10.0957L8.00194 17.4256C6.69531 17.9327 6.71509 18.6611 7.77982 18.9912L12.6745 20.5136L24.0438 13.3996C24.5789 13.0453 25.0654 13.2413 24.6652 13.5956L15.4685 21.8535Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1283_681">
        <rect width="37" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RightArrowBtnIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 6L11.5 1M16.5 6L11.5 11M16.5 6L10 6M6.5 6C4.83333 6 1.5 7 1.5 11"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowIcon = () => (
  <svg
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 15L7 8L1 1"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowIcon = () => (
  <svg
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 15L1 8L7 1"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseGradientIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M13.5071 11.4154L22.3972 2.52523C22.9757 1.94695 22.9757 1.01192 22.3972 0.433711C21.8189 -0.14457 20.8839 -0.14457 20.3057 0.433711L11.4154 9.32385L2.52544 0.433711C1.94688 -0.14457 1.0122 -0.14457 0.433919 0.433711C-0.14464 1.01199 -0.14464 1.94695 0.433919 2.52523L9.32378 11.4154L0.433988 20.3056C-0.14457 20.8839 -0.14457 21.8189 0.433988 22.3971C0.57116 22.5347 0.734161 22.6438 0.913626 22.7181C1.09309 22.7925 1.28548 22.8307 1.47975 22.8305C1.85834 22.8305 2.23706 22.6856 2.52551 22.3971L11.4154 13.507L20.3057 22.3971C20.4428 22.5346 20.6058 22.6437 20.7853 22.7181C20.9648 22.7925 21.1572 22.8307 21.3514 22.8305C21.73 22.8305 22.1087 22.6856 22.3972 22.3971C22.9757 21.8188 22.9757 20.8839 22.3972 20.3056L13.5071 11.4154Z"
      fill="url(#paint0_linear_590_1354)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_590_1354"
        x1="18.7286"
        y1="22.8305"
        x2="-1.04405"
        y2="20.6335"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEB84D" />
        <stop offset="1" stop-color="#EF7027" />
      </linearGradient>
    </defs>
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.47301 0 0 4.4725 0 10C0 15.5269 4.4725 20 10 20C15.527 20 20 15.5275 20 10C20 4.47309 15.5275 0 10 0ZM10 18.6046C5.25539 18.6046 1.39535 14.7446 1.39535 10C1.39535 5.25535 5.25539 1.39535 10 1.39535C14.7446 1.39535 18.6046 5.25535 18.6046 10C18.6046 14.7446 14.7446 18.6046 10 18.6046Z"
      fill="white"
    />
    <path
      d="M10.0002 8.33575C9.40789 8.33575 8.98668 8.58591 8.98668 8.95446V13.9695C8.98668 14.2855 9.40789 14.6013 10.0002 14.6013C10.5663 14.6013 11.0269 14.2855 11.0269 13.9695V8.95438C11.0269 8.58587 10.5663 8.33575 10.0002 8.33575ZM10.0002 5.24243C9.39473 5.24243 8.9209 5.67681 8.9209 6.177C8.9209 6.67724 9.39477 7.12478 10.0002 7.12478C10.5926 7.12478 11.0665 6.67724 11.0665 6.177C11.0665 5.67681 10.5925 5.24243 10.0002 5.24243Z"
      fill="white"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1V4H1L1 1H6ZM1 0C0.447715 0 0 0.447715 0 1V4C0 4.55228 0.447715 5 1 5H6C6.55228 5 7 4.55228 7 4V1C7 0.447715 6.55228 0 6 0H1Z"
      fill="#ffffff"
    />
    <path
      d="M15 12V15H10V12H15ZM10 11C9.44772 11 9 11.4477 9 12V15C9 15.5523 9.44772 16 10 16H15C15.5523 16 16 15.5523 16 15V12C16 11.4477 15.5523 11 15 11H10Z"
      fill="#ffffff"
    />
    <path
      d="M6 8V15H1L1 8H6ZM1 7C0.447715 7 0 7.44772 0 8V15C0 15.5523 0.447715 16 1 16H6C6.55228 16 7 15.5523 7 15V8C7 7.44772 6.55228 7 6 7H1Z"
      fill="#ffffff"
    />
    <path
      d="M15 1V8H10V1H15ZM10 0C9.44772 0 9 0.447715 9 1V8C9 8.55229 9.44772 9 10 9H15C15.5523 9 16 8.55229 16 8V1C16 0.447715 15.5523 0 15 0H10Z"
      fill="#ffffff"
    />
  </svg>
);

export const FundsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 6.17071V5C20 3.34315 18.6569 2 17 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V9C22 7.69378 21.1652 6.58254 20 6.17071ZM4 5C4 4.44772 4.44772 4 5 4H17C17.5523 4 18 4.44772 18 5V6H5C4.44772 6 4 5.55228 4 5ZM4 7.82929C4.31278 7.93985 4.64936 8 5 8H19C19.5523 8 20 8.44771 20 9V11H17C15.3431 11 14 12.3431 14 14C14 15.6569 15.3431 17 17 17H20V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V7.82929ZM17 13H20V15H17C16.4477 15 16 14.5523 16 14C16 13.4477 16.4477 13 17 13Z"
      fill="white"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.5 1V8H8.5V1H7.5Z" fill="white" />
    <path
      d="M3 8.81244C3 6.93059 4.03942 5.29082 5.57785 4.43714L5.09264 3.56274C3.24937 4.58557 2 6.55276 2 8.81244C2 12.1262 4.68629 14.8124 8 14.8124C11.3137 14.8124 14 12.1262 14 8.81244C14 6.59097 12.7925 4.65212 11.0004 3.61544L10.4996 4.48105C11.9954 5.34633 13 6.96237 13 8.81244C13 11.5739 10.7614 13.8124 8 13.8124C5.23858 13.8124 3 11.5739 3 8.81244Z"
      fill="white"
    />
  </svg>
);

export const NoRecord = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="53.914"
    height="53.913"
    viewBox="0 0 53.914 53.913"
  >
    <defs>
      <clipPath id="clipPath">
        <rect
          id="Rectangle_7483"
          width="53.914"
          height="53.913"
          transform="translate(0 0)"
          fill="#f68630"
        />
      </clipPath>
    </defs>
    <g id="Group_37907" transform="translate(0 0)">
      <g id="Group_37906">
        <path
          id="Path_11928"
          d="M5.057,0H27.379q0,5.9,0,11.792c0,1.3.592,1.9,1.892,1.9H41.046v5.541a12.609,12.609,0,0,0-13.335,5.466C25,29.05,24.8,33.6,27.439,37.987c3.066,5.088,7.782,6.888,13.629,5.986,0,1.307,0,2.621,0,3.935a5.792,5.792,0,0,1-6.008,6Q20.529,53.916,6,53.9a6.6,6.6,0,0,1-1.511-.157A5.763,5.763,0,0,1,0,47.948Q0,32.971,0,17.993C0,13.957,0,9.921,0,5.885A5.484,5.484,0,0,1,2.518,1.059,14.216,14.216,0,0,1,5.057,0m11.76,20.007q4.443,0,8.888,0a1.578,1.578,0,1,0,.039-3.153q-8.887-.009-17.776.009a1.969,1.969,0,0,0-.937.273,1.494,1.494,0,0,0-.653,1.688A1.57,1.57,0,0,0,7.981,20q4.417.009,8.836,0M14.8,23.165q-3.366,0-6.731,0a1.587,1.587,0,1,0,.013,3.156q6.653,0,13.3,0a1.591,1.591,0,1,0-.014-3.158q-3.286,0-6.572,0m-.057,9.476q3.365,0,6.73,0a1.583,1.583,0,1,0-.031-3.158q-6.7-.006-13.408,0a1.585,1.585,0,1,0,.031,3.156q3.339.006,6.678,0m-.012,6.318q3.339,0,6.678,0a1.588,1.588,0,1,0-.007-3.157q-6.653,0-13.3,0a1.59,1.59,0,1,0,.007,3.157q3.312,0,6.625,0"
          fill="#f68630"
        />
        <path
          id="Path_11929"
          d="M53.914,46.014a1.763,1.763,0,0,1-1.193,1.152,1.669,1.669,0,0,1-1.622-.52q-3.43-3.453-6.88-6.891a5.967,5.967,0,0,1-.386-.467,9.471,9.471,0,0,1-8.479,1.306,9.192,9.192,0,0,1-5.113-4A9.471,9.471,0,0,1,44.155,24.159a9.541,9.541,0,0,1,1.873,12.928c.125.131.252.272.386.406,2.22,2.221,4.447,4.436,6.655,6.669a10.136,10.136,0,0,1,.845,1.115Z"
          fill="#f68630"
        />
        <path
          id="Path_11930"
          d="M39.843,10.5H30.581V1.238L39.843,10.5"
          fill="#f68630"
        />
      </g>
    </g>
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00004 4.75421C6.20745 4.75421 4.75427 6.20739 4.75427 7.99997C4.75427 9.79256 6.20745 11.2457 8.00004 11.2457C9.79262 11.2457 11.2458 9.79256 11.2458 7.99997C11.2458 6.20739 9.79262 4.75421 8.00004 4.75421ZM5.75427 7.99997C5.75427 6.75967 6.75973 5.75421 8.00004 5.75421C9.24034 5.75421 10.2458 6.75967 10.2458 7.99997C10.2458 9.24027 9.24034 10.2457 8.00004 10.2457C6.75973 10.2457 5.75427 9.24027 5.75427 7.99997Z"
      fill="#ffffff"
    />
    <path
      d="M9.79647 1.34338C9.26853 -0.447793 6.73147 -0.447791 6.20353 1.34338L6.10968 1.66179C5.95246 2.19519 5.34321 2.44755 4.85487 2.18155L4.56336 2.02276C2.9235 1.12953 1.12953 2.9235 2.02276 4.56336L2.18155 4.85487C2.44755 5.34321 2.19519 5.95246 1.66179 6.10968L1.34338 6.20353C-0.447793 6.73147 -0.447791 9.26853 1.34338 9.79647L1.66179 9.89032C2.19519 10.0475 2.44755 10.6568 2.18155 11.1451L2.02276 11.4366C1.12953 13.0765 2.92349 14.8705 4.56335 13.9772L4.85487 13.8184C5.34321 13.5524 5.95246 13.8048 6.10968 14.3382L6.20353 14.6566C6.73147 16.4478 9.26853 16.4478 9.79647 14.6566L9.89032 14.3382C10.0475 13.8048 10.6568 13.5524 11.1451 13.8184L11.4366 13.9772C13.0765 14.8705 14.8705 13.0765 13.9772 11.4366L13.8184 11.1451C13.5524 10.6568 13.8048 10.0475 14.3382 9.89032L14.6566 9.79647C16.4478 9.26853 16.4478 6.73147 14.6566 6.20353L14.3382 6.10968C13.8048 5.95246 13.5524 5.34321 13.8184 4.85487L13.9772 4.56335C14.8705 2.92349 13.0765 1.12953 11.4366 2.02276L11.1451 2.18155C10.6568 2.44755 10.0475 2.19519 9.89032 1.66179L9.79647 1.34338ZM7.16273 1.6261C7.40879 0.7913 8.59121 0.791301 8.83727 1.6261L8.93112 1.94451C9.26845 3.08899 10.5757 3.63046 11.6235 3.05972L11.915 2.90094C12.6793 2.48463 13.5154 3.32074 13.0991 4.08501L12.9403 4.37653C12.3695 5.42433 12.911 6.73155 14.0555 7.06888L14.3739 7.16273C15.2087 7.40879 15.2087 8.59121 14.3739 8.83727L14.0555 8.93112C12.911 9.26845 12.3695 10.5757 12.9403 11.6235L13.0991 11.915C13.5154 12.6793 12.6793 13.5154 11.915 13.0991L11.6235 12.9403C10.5757 12.3695 9.26845 12.911 8.93112 14.0555L8.83727 14.3739C8.59121 15.2087 7.40879 15.2087 7.16273 14.3739L7.06888 14.0555C6.73155 12.911 5.42433 12.3695 4.37653 12.9403L4.08501 13.0991C3.32074 13.5154 2.48463 12.6793 2.90093 11.915L3.05972 11.6235C3.63046 10.5757 3.089 9.26845 1.94452 8.93112L1.6261 8.83727C0.7913 8.59121 0.791301 7.40879 1.6261 7.16273L1.94451 7.06888C3.08899 6.73155 3.63046 5.42433 3.05972 4.37653L2.90093 4.08501C2.48463 3.32073 3.32074 2.48463 4.08501 2.90093L4.37653 3.05972C5.42432 3.63046 6.73155 3.089 7.06888 1.94452L7.16273 1.6261Z"
      fill="#ffffff"
    />
  </svg>
);

export const APYIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_1672_937)">
      <path
        d="M4.66242 8.20188V18.7839C4.66242 19.0086 4.47948 19.1901 4.25448 19.1901H1.21506C1.10734 19.19 1.00404 19.1472 0.927836 19.0711C0.851633 18.9949 0.80875 18.8917 0.808594 18.7839V8.20188C0.808594 7.97717 0.991829 7.7957 1.21506 7.7957H4.25448C4.47948 7.7957 4.66242 7.97717 4.66242 8.20188ZM10.2565 4.1807V18.7836C10.2565 19.0086 10.0736 19.1901 9.84859 19.1901H6.80889C6.70121 19.19 6.59799 19.1471 6.52185 19.071C6.44571 18.9948 6.40287 18.8916 6.40271 18.7839V4.1807C6.40271 3.9557 6.58565 3.77423 6.80889 3.77423H9.84859C10.0736 3.77423 10.2565 3.9557 10.2565 4.1807ZM15.8507 10.0892V18.7839C15.8507 19.0086 15.6674 19.1901 15.4427 19.1901H12.403C12.2953 19.19 12.1921 19.1471 12.116 19.071C12.0398 18.9948 11.997 18.8916 11.9968 18.7839V10.0892C11.9968 9.86423 12.1798 9.68276 12.403 9.68276H15.4427C15.6674 9.68276 15.8507 9.86423 15.8507 10.0892ZM14.6124 3.66099C14.6171 3.72511 14.6359 3.77746 14.6704 3.82158C14.7136 3.87658 14.8683 3.87717 14.9121 3.82129C14.9471 3.77493 14.9672 3.71903 14.9698 3.66099C14.9757 3.57158 14.9801 3.38629 14.9698 3.24687C14.9668 3.18687 14.946 3.12912 14.9101 3.08099C14.893 3.05835 14.8527 3.04688 14.7912 3.04688C14.7295 3.04688 14.6895 3.05835 14.6718 3.08129C14.6365 3.12776 14.6171 3.18158 14.6124 3.24599C14.6103 3.38422 14.6103 3.52277 14.6124 3.66099ZM16.5809 5.15923C16.578 5.09936 16.5573 5.04171 16.5215 4.99364C16.5045 4.97129 16.4642 4.95982 16.4024 4.95982C16.3601 4.95982 16.3051 4.9657 16.2833 4.99393C16.248 5.0404 16.2286 5.09452 16.2239 5.15923L16.2151 5.28129C16.2074 5.40687 16.2209 5.50688 16.2239 5.57364C16.2286 5.63776 16.2474 5.69011 16.2815 5.73364C16.3251 5.78952 16.4798 5.78952 16.5233 5.73393C16.5584 5.68761 16.5785 5.63169 16.5809 5.57364C16.589 5.43572 16.589 5.29715 16.5809 5.15923Z"
        fill="url(#paint0_linear_1672_937)"
      />
      <path
        d="M15.5932 0.810059C13.6046 0.810059 11.9961 2.41829 11.9961 4.40712C11.9961 6.39594 13.6046 8.00418 15.5932 8.00418C17.574 8.00418 19.1902 6.39594 19.1902 4.40712C19.1902 2.41829 17.574 0.810059 15.5932 0.810059ZM14.1693 3.21329C14.1799 3.06359 14.2299 2.928 14.3184 2.81212C14.3911 2.71682 14.532 2.603 14.7905 2.603C15.1843 2.603 15.3882 2.88682 15.4117 3.21418C15.422 3.35565 15.4208 3.56124 15.4117 3.69182C15.4008 3.84506 15.3499 3.98006 15.2614 4.09447C15.1879 4.188 15.0473 4.29859 14.7908 4.29859C14.5343 4.29859 14.3929 4.188 14.3202 4.09506C14.2303 3.97923 14.1777 3.83882 14.1693 3.69241C14.1682 3.563 14.1426 3.54859 14.1693 3.21329ZM14.5758 6.11271C14.539 6.15603 14.487 6.1836 14.4305 6.18974C14.374 6.19588 14.3173 6.18012 14.2721 6.14571C14.2268 6.11129 14.1965 6.06084 14.1874 6.00475C14.1782 5.94866 14.1909 5.89119 14.2229 5.84418L16.6108 2.70182C16.6464 2.65502 16.6992 2.6243 16.7575 2.61641C16.8158 2.60852 16.8749 2.62412 16.9217 2.65976C16.9685 2.69541 16.9992 2.74819 17.0071 2.8065C17.015 2.8648 16.9994 2.92384 16.9637 2.97065L14.5758 6.11271ZM17.0229 5.60476C16.9993 5.93565 16.7961 6.21124 16.4017 6.21124C16.0193 6.21124 15.8052 5.94653 15.7805 5.60565C15.7761 5.483 15.7564 5.43212 15.7805 5.12624C15.7914 4.97565 15.8417 4.84035 15.9299 4.72476C16.0023 4.62947 16.1432 4.51594 16.4017 4.51594C16.6599 4.51594 16.8008 4.62947 16.8734 4.72476C16.962 4.84065 17.012 4.97594 17.0229 5.12712C17.0325 5.28619 17.0325 5.4457 17.0229 5.60476Z"
        fill="url(#paint1_linear_1672_937)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1672_937"
        x1="13.7518"
        y1="19.1901"
        x2="0.0795986"
        y2="17.7053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEB84D" />
        <stop offset="1" stop-color="#EF7027" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1672_937"
        x1="17.8975"
        y1="8.00418"
        x2="11.6671"
        y2="7.31193"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEB84D" />
        <stop offset="1" stop-color="#EF7027" />
      </linearGradient>
      <clipPath id="clip0_1672_937">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StakeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_1664_934)">
      <path
        d="M19.1661 10C19.1662 9.84519 19.1231 9.69337 19.0417 9.56163C18.9603 9.42989 18.8438 9.32343 18.7053 9.25421L16.0295 7.91671L18.7053 6.58338C18.844 6.51427 18.9606 6.40786 19.0422 6.27611C19.1237 6.14436 19.1669 5.99249 19.1669 5.83755C19.1669 5.68261 19.1237 5.53073 19.0422 5.39898C18.9606 5.26723 18.844 5.16083 18.7053 5.09171L10.372 0.925047C10.2563 0.867248 10.1288 0.837158 9.99948 0.837158C9.87017 0.837158 9.74264 0.867248 9.62698 0.925047L1.29364 5.09171C1.15497 5.16083 1.03831 5.26723 0.95677 5.39898C0.875228 5.53073 0.832031 5.68261 0.832031 5.83755C0.832031 5.99249 0.875228 6.14436 0.95677 6.27611C1.03831 6.40786 1.15497 6.51427 1.29364 6.58338L3.96948 7.91671L1.29364 9.25421C1.15497 9.32333 1.03831 9.42973 0.95677 9.56148C0.875228 9.69323 0.832031 9.84511 0.832031 10C0.832031 10.155 0.875228 10.3069 0.95677 10.4386C1.03831 10.5704 1.15497 10.6768 1.29364 10.7459L3.96948 12.0834L1.29364 13.4209C1.15497 13.49 1.03831 13.5964 0.95677 13.7282C0.875228 13.8599 0.832031 14.0118 0.832031 14.1667C0.832031 14.3217 0.875228 14.4735 0.95677 14.6053C1.03831 14.737 1.15497 14.8434 1.29364 14.9125L9.62698 19.0792C9.74264 19.137 9.87017 19.1671 9.99948 19.1671C10.1288 19.1671 10.2563 19.137 10.372 19.0792L18.7053 14.9125C18.844 14.8434 18.9606 14.737 19.0422 14.6053C19.1237 14.4735 19.1669 14.3217 19.1669 14.1667C19.1669 14.0118 19.1237 13.8599 19.0422 13.7282C18.9606 13.5964 18.844 13.49 18.7053 13.4209L16.0295 12.0834L18.7053 10.75C18.8445 10.6805 18.9614 10.5734 19.0428 10.4409C19.1243 10.3083 19.167 10.1556 19.1661 10ZM16.4695 14.1667L9.99948 17.4017L3.52948 14.1667L5.83281 13.015L9.62698 14.9167C9.74264 14.9745 9.87017 15.0046 9.99948 15.0046C10.1288 15.0046 10.2563 14.9745 10.372 14.9167L14.1661 13.015L16.4695 14.1667ZM9.99948 13.235L3.52948 10L5.83281 8.84838L9.62698 10.75C9.74264 10.8078 9.87017 10.8379 9.99948 10.8379C10.1288 10.8379 10.2563 10.8078 10.372 10.75L14.1661 8.84838L16.4695 10L9.99948 13.235Z"
        fill="url(#paint0_linear_1664_934)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1664_934"
        x1="15.8724"
        y1="19.1671"
        x2="-0.00631709"
        y2="17.4024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEB84D" />
        <stop offset="1" stop-color="#EF7027" />
      </linearGradient>
      <clipPath id="clip0_1664_934">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StakeNewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_1664_934)">
      <path
        d="M19.1661 10C19.1662 9.84519 19.1231 9.69337 19.0417 9.56163C18.9603 9.42989 18.8438 9.32343 18.7053 9.25421L16.0295 7.91671L18.7053 6.58338C18.844 6.51427 18.9606 6.40786 19.0422 6.27611C19.1237 6.14436 19.1669 5.99249 19.1669 5.83755C19.1669 5.68261 19.1237 5.53073 19.0422 5.39898C18.9606 5.26723 18.844 5.16083 18.7053 5.09171L10.372 0.925047C10.2563 0.867248 10.1288 0.837158 9.99948 0.837158C9.87017 0.837158 9.74264 0.867248 9.62698 0.925047L1.29364 5.09171C1.15497 5.16083 1.03831 5.26723 0.95677 5.39898C0.875228 5.53073 0.832031 5.68261 0.832031 5.83755C0.832031 5.99249 0.875228 6.14436 0.95677 6.27611C1.03831 6.40786 1.15497 6.51427 1.29364 6.58338L3.96948 7.91671L1.29364 9.25421C1.15497 9.32333 1.03831 9.42973 0.95677 9.56148C0.875228 9.69323 0.832031 9.84511 0.832031 10C0.832031 10.155 0.875228 10.3069 0.95677 10.4386C1.03831 10.5704 1.15497 10.6768 1.29364 10.7459L3.96948 12.0834L1.29364 13.4209C1.15497 13.49 1.03831 13.5964 0.95677 13.7282C0.875228 13.8599 0.832031 14.0118 0.832031 14.1667C0.832031 14.3217 0.875228 14.4735 0.95677 14.6053C1.03831 14.737 1.15497 14.8434 1.29364 14.9125L9.62698 19.0792C9.74264 19.137 9.87017 19.1671 9.99948 19.1671C10.1288 19.1671 10.2563 19.137 10.372 19.0792L18.7053 14.9125C18.844 14.8434 18.9606 14.737 19.0422 14.6053C19.1237 14.4735 19.1669 14.3217 19.1669 14.1667C19.1669 14.0118 19.1237 13.8599 19.0422 13.7282C18.9606 13.5964 18.844 13.49 18.7053 13.4209L16.0295 12.0834L18.7053 10.75C18.8445 10.6805 18.9614 10.5734 19.0428 10.4409C19.1243 10.3083 19.167 10.1556 19.1661 10ZM16.4695 14.1667L9.99948 17.4017L3.52948 14.1667L5.83281 13.015L9.62698 14.9167C9.74264 14.9745 9.87017 15.0046 9.99948 15.0046C10.1288 15.0046 10.2563 14.9745 10.372 14.9167L14.1661 13.015L16.4695 14.1667ZM9.99948 13.235L3.52948 10L5.83281 8.84838L9.62698 10.75C9.74264 10.8078 9.87017 10.8379 9.99948 10.8379C10.1288 10.8379 10.2563 10.8078 10.372 10.75L14.1661 8.84838L16.4695 10L9.99948 13.235Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7422 10.3439C12.5329 9.2673 13 7.9382 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13C7.93858 13 9.26801 12.5327 10.3448 11.7415L10.3439 11.7422C10.3734 11.7822 10.4062 11.8204 10.4424 11.8566L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L11.8566 10.4424C11.8204 10.4062 11.7822 10.3734 11.7422 10.3439ZM12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5Z"
      fill="black"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M10.5 6C10.5 7.38071 9.38071 8.5 8 8.5C6.61929 8.5 5.5 7.38071 5.5 6C5.5 4.61929 6.61929 3.5 8 3.5C9.38071 3.5 10.5 4.61929 10.5 6Z"
      fill="currentColor"
    />
    <path
      d="M0 6C0 6 3 0.5 8 0.5C13 0.5 16 6 16 6C16 6 13 11.5 8 11.5C3 11.5 0 6 0 6ZM8 9.5C9.933 9.5 11.5 7.933 11.5 6C11.5 4.067 9.933 2.5 8 2.5C6.067 2.5 4.5 4.067 4.5 6C4.5 7.933 6.067 9.5 8 9.5Z"
      fill="currentColor"
    />
  </svg>
);

export const EyeCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <path
      d="M10.7904 11.9116L9.17617 10.2974C8.80858 10.4286 8.41263 10.5 8 10.5C6.067 10.5 4.5 8.93297 4.5 6.99998C4.5 6.58735 4.5714 6.1914 4.70253 5.82381L2.64112 3.7624C0.938717 5.279 0 6.99998 0 6.99998C0 6.99998 3 12.5 8 12.5C9.01539 12.5 9.9483 12.2732 10.7904 11.9116Z"
      fill="currentColor"
    />
    <path
      d="M5.20967 2.08831C6.05172 1.7268 6.98462 1.49998 8 1.49998C13 1.49998 16 6.99998 16 6.99998C16 6.99998 15.0613 8.72095 13.3589 10.2375L11.2975 8.17612C11.4286 7.80854 11.5 7.41259 11.5 6.99998C11.5 5.06698 9.933 3.49998 8 3.49998C7.58738 3.49998 7.19144 3.57138 6.82386 3.7025L5.20967 2.08831Z"
      fill="currentColor"
    />
    <path
      d="M5.52485 6.64613C5.50847 6.76172 5.5 6.87986 5.5 6.99998C5.5 8.38069 6.61929 9.49998 8 9.49998C8.12012 9.49998 8.23825 9.49151 8.35385 9.47513L5.52485 6.64613Z"
      fill="currentColor"
    />
    <path
      d="M10.4752 7.3538L7.64618 4.52482C7.76176 4.50845 7.87989 4.49998 8 4.49998C9.38071 4.49998 10.5 5.61926 10.5 6.99998C10.5 7.12008 10.4915 7.23821 10.4752 7.3538Z"
      fill="currentColor"
    />
    <path
      d="M13.6464 13.3535L1.64645 1.35353L2.35355 0.646423L14.3536 12.6464L13.6464 13.3535Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6.5C11 6.22386 11.2239 6 11.5 6H12.5C12.7761 6 13 6.22386 13 6.5V7.5C13 7.77614 12.7761 8 12.5 8H11.5C11.2239 8 11 7.77614 11 7.5V6.5Z"
      fill="#ef7027"
    />
    <path
      d="M8 6.5C8 6.22386 8.22386 6 8.5 6H9.5C9.77614 6 10 6.22386 10 6.5V7.5C10 7.77614 9.77614 8 9.5 8H8.5C8.22386 8 8 7.77614 8 7.5V6.5Z"
      fill="#ef7027"
    />
    <path
      d="M3 9.5C3 9.22386 3.22386 9 3.5 9H4.5C4.77614 9 5 9.22386 5 9.5V10.5C5 10.7761 4.77614 11 4.5 11H3.5C3.22386 11 3 10.7761 3 10.5V9.5Z"
      fill="#ef7027"
    />
    <path
      d="M6 9.5C6 9.22386 6.22386 9 6.5 9H7.5C7.77614 9 8 9.22386 8 9.5V10.5C8 10.7761 7.77614 11 7.5 11H6.5C6.22386 11 6 10.7761 6 10.5V9.5Z"
      fill="#ef7027"
    />
    <path
      d="M3.5 0C3.77614 0 4 0.223858 4 0.5V1H12V0.5C12 0.223858 12.2239 0 12.5 0C12.7761 0 13 0.223858 13 0.5V1H14C15.1046 1 16 1.89543 16 3V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3C0 1.89543 0.895431 1 2 1H3V0.5C3 0.223858 3.22386 0 3.5 0ZM1 4V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V4H1Z"
      fill="#ef7027"
    />
  </svg>
);

export const GreenBGIcon = () => (
  <svg
    width="95"
    height="95"
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_783_9118)">
      <path
        d="M47.5 95C73.7335 95 95 73.7335 95 47.5C95 21.2665 73.7335 0 47.5 0C21.2665 0 0 21.2665 0 47.5C0 73.7335 21.2665 95 47.5 95Z"
        fill="#3ECA7F"
      />
      <path
        d="M32.2252 47.8869C31.5385 47.1516 30.3523 47.0903 29.6032 47.7644C28.854 48.4384 28.7916 49.6027 29.4783 50.338L38.9053 60.3872C39.2799 60.7549 39.7169 61 40.2163 61H40.2787C40.7782 61 41.2776 60.8162 41.5898 60.4485L65.4381 37.1023C66.1873 36.367 66.1873 35.2028 65.4381 34.5288C64.689 33.8547 63.5028 33.7934 62.8161 34.5288L40.3412 56.5268L32.2252 47.8869Z"
        fill="white"
        stroke="white"
        strokeWidth="1.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_9118">
        <rect width="95" height="95" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// export const SearchIcon = () => (

// );

// export const SearchIcon = () => (

// );

